import gql from 'graphql-tag';
import {Window} from './fragments';

// export const AllImagesQuery = gql`
//   query allImages {
//     allImages(width: 300, height: 240) {
//       ...SimpleMedia
//     }
//   }
//   ${SimpleMedia}
// `;
//
// export const AllImagesQueryConfig = {name: 'imagesQuery'};
//
// export const AllDocumentsQuery = gql`
//   query allDocuments {
//     allDocuments {
//       ...SimpleMedia
//     }
//   }
//   ${SimpleMedia}
// `;
//
// export const AllDocumentsQueryConfig = {name: 'documentsQuery'};

// export const MessageQueryConfig = {
//   name: 'messageQuery',
//   options: props => {
//     return {variables: {_id: props.match.params.id}};
//   },
//   props: ({messageQuery: {news, poll, job, voting, ...data}, ...props}) => ({
//     messageQuery: {message: news || poll || job || voting, ...data},
//     ...props,
//   }),
// };
//
// export const ReceiversQueryConfig = {name: 'receiversQuery'};

export const SearchWindowsQuery = gql`
  query searchWindows(
    $name: String, 
    $winType: String, 
    $winClass: String,
    $variation: String, 
    $uValueFrame: String, 
    $uValueGlass: String, 
    $windLoad: String,
    $drivingRain: String,
    $psiValue: String,
    $rainRackType: String,
    $coatingType: String,
    $wingSeal: String,
    $foldSeal: String,
    $glassType: String,
    $placeholder: String,
    $rainRackProd: String,
    $coatingProd: String,
    $sealProd: String,
    $profileDie: String,
    $airPermeable: String,
    $operateForce: String,
    $mechanicalStress: String,
    $thermalInsulation: String,
    $soundInsulation: String,
    $serialNumber: String,
    $qualityReportNumber: String,
    $height: String,
    $width: String,
    $completeSurface: String
  ) {
    searchWindows(
      name: $name, 
      winType: $winType,
      winClass: $winClass,
      variation: $variation,
      uValueFrame: $uValueFrame,
      uValueGlass: $uValueGlass,
      windLoad: $windLoad,
      drivingRain: $drivingRain,
      psiValue: $psiValue,
      rainRackType: $rainRackType,
      coatingType: $coatingType,
      wingSeal: $wingSeal,
      foldSeal: $foldSeal,
      glassType: $glassType,
      placeholder: $placeholder,
      rainRackProd: $rainRackProd,
      coatingProd: $coatingProd,
      sealProd: $sealProd,
      profileDie: $profileDie
      airPermeable: $airPermeable
      operateForce: $operateForce 
      mechanicalStress: $mechanicalStress 
      thermalInsulation: $thermalInsulation
      soundInsulation: $soundInsulation
      serialNumber: $serialNumber
      qualityReportNumber: $qualityReportNumber
      height: $height 
      width: $width
      completeSurface: $completeSurface
    ) {
      ...Window
    }
  }
  ${Window}
`;

export const SearchWindowQueryConfig = {
  name: 'searchWindowsQuery',
  options: ({searchOptions}) => {
    return {variables: searchOptions, fetchPolicy: 'network-only'};
  },
};



// WEBPACK FOOTER //
// ./src/qql-shared/queries.js